import { CountryManagementState } from './types';

export const state = (): CountryManagementState => initialState();

export const initialState = (): CountryManagementState => ({
  countries: [],
});
